import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 22 30"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#000",
  "fill-rule": "evenodd",
  d: "M20.429 1.579H1.57V28.42H20.43zM1.57 0C.704 0 0 .707 0 1.579V28.42C0 29.293.704 30 1.571 30H20.43c.867 0 1.571-.707 1.571-1.579V1.58C22 .707 21.296 0 20.429 0z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#000",
  "fill-rule": "evenodd",
  d: "M20.429 25.263H0v-1.579h20.429zM5.73 12.074a.783.783 0 0 1 1.112 0l2.777 2.79 6.112-6.14a.783.783 0 0 1 1.111 0 .79.79 0 0 1 0 1.117L9.62 17.098 5.73 13.19a.79.79 0 0 1 0-1.116",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }